import { cn, getPdpPrice, transMoney, useI18n } from "@jog/react-components"
import { PdpProduct } from "@jog/types"

export const PdpPrice = ({ productData, showLabel }: { productData: PdpProduct; showLabel?: boolean }) => {
    const { currentPrice, lowestPrice, originPrice, off } = getPdpPrice(productData)
    const { $t } = useI18n()
    return (
        <div data-test="product-price">
            <div className="flex items-center">
                <div className={cn("text-26 font-medium leading-6", off > 0 ? "text-red-sale" : "text-black")}>
                    {transMoney(currentPrice)}
                </div>
                {off > 0 && showLabel ? (
                    <div className="relative ml-20 flex bg-[#D32137] py-1 px-4 text-xs text-white">
                        <span>{`${off}` + $t("Label")}</span>
                    </div>
                ) : (
                    <></>
                )}
            </div>
            {off > 0 ? (
                <div className="mt-4 text-sm text-grey-dark">
                    <div>{$t(`Original price: {price}`, { price: transMoney(originPrice, { EUR: false }) })}</div>
                    {lowestPrice === currentPrice || lowestPrice === originPrice ? null : (
                        <div>
                            {$t(`Lowest price last 30 days: {price}`, {
                                price: transMoney(lowestPrice, { EUR: false }),
                            })}
                        </div>
                    )}
                </div>
            ) : (
                <></>
            )}
        </div>
    )
}
